import _ from "underscore";

import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";

import Icon from "../elements/icon";

import Button from "../elements/button";

export default class extends React.Component {
  static displayName = "ModalConfirm";

  static propTypes = {
    type: PropTypes.string,
    header: PropTypes.any,
    hasMargin: PropTypes.bool,
    saveLabel: PropTypes.any,
    cancelLabel: PropTypes.any,
    disableSave: PropTypes.bool,
    disableCancel: PropTypes.bool,
    allowClose: PropTypes.bool,
    closeOnSubmit: PropTypes.bool,
    closeModal: PropTypes.func,
    onSubmit: PropTypes.func,
    onCancel: PropTypes.func,
    style: PropTypes.object,
    buttonActionClass: PropTypes.string,
    buttonCancelClass: PropTypes.string,
    saveButtonType: PropTypes.string,
  };

  static defaultProps = {
    type: "default",
    saveLabel: "Save",
    cancelLabel: "Cancel",
    allowClose: true,
    closeOnSubmit: true,
    style: {},
  };

  handleSubmit = () => {
    if (_.isFunction(this.props.onSubmit) && !this.props.disableSave) {
      this.props.onSubmit();
      if (this.props.closeOnSubmit) {
        this.handleHide();
      }
    }
  };

  handleCancel = () => {
    if (!this.props.disableCancel) {
      if (typeof this.props.onCancel === "function") {
        this.props.onCancel();
      }
      this.handleHide();
    }
  };

  handleHide = () => (typeof this.props.closeModal === "function" ? this.props.closeModal() : undefined);

  render() {
    const bodyClass = classNames("et--modal-confirm--body", {
      "et--modal-confirm--content": this.props.hasMargin,
    });

    return (
      <div style={this.props.style} className={`et--modal-confirm ${this.props.className || ""}`}>
        <div className="et--modal-confirm--header">
          <h3>
            {this.props.header}
            {this.props.allowClose ? (
              <Icon className="et--modal-confirm--close" icon="close" onClick={this.handleCancel} />
            ) : (
              undefined
            )}
          </h3>
        </div>
        <div className={bodyClass}>
          {_.isFunction(this.props.children.type)
            ? React.cloneElement(this.props.children, {
                closeModal: this.props.closeModal,
              })
            : this.props.children}
        </div>
        {this.props.onSubmit ? (
          <div className="et--modal-confirm--footer">
            <Button
              type="secondary"
              className={classNames("et--modal-confirm--cancel", this.props.buttonCancelClass)}
              disabled={this.props.disableCancel}
              onClick={this.handleCancel}
            >
              {this.props.cancelLabel}
            </Button>

            <Button
              type={this.props.type}
              disabled={this.props.disableSave}
              buttonType={this.props.saveButtonType}
              className={classNames("et--modal-confirm--submit", this.props.buttonActionClass)}
              onClick={this.handleSubmit}
            >
              {this.props.saveLabel}
            </Button>
          </div>
        ) : (
          undefined
        )}
      </div>
    );
  }
}
